define(
  'getCounts',[
    'ajaxHelper',
    'configResultsCounts',
    'searchTypeHelper'
  ],
  (
    ajaxHelper,
    configResultsCounts,
    searchTypeHelper
  ) => {
    'use strict';

    const partnerUrl = document.querySelector('.brand-logo, #nhs_HeaderLogo').href;
    let defaultAjaxUrl;
    let globalCallback;

    /**
   * @private
   * handleSuccessEvent: callback to be executed after a request was success.
   *
   * @param {object} value that is returned from the request made.
   */
    function handleSuccessEvent(value) {
      if (typeof globalCallback !== 'function') {
        return;
      }

      const data = {
        subscribers: ['countsHandling'],
        response: JSON.parse(value)
      };

      globalCallback(data);
    }

    /**
   * @public
   * getResults: method to get the results from API.
   *
   * @param {object} parameters from search params object.
   * @param {function} callback to be excuted after a response end.
   */
    function getCounts(parameters, callback) {
      const searchResultType = searchTypeHelper.getSrpType();
      const ajaxUrl = defaultAjaxUrl;
      globalCallback = callback;

      ajaxHelper.postRequest(
        ajaxUrl,
        {
          async: true,
          abort: true,
          data: {
            currentSearchParams: parameters,
            isCommResults: searchTypeHelper.isAnyCommunitySearchType(searchResultType)
          },
          requestHeaders: [
            {
              name: 'Content-Type',
              value: 'application/json'
            }
          ],
          success: handleSuccessEvent
        }
      );
    }

    defaultAjaxUrl = partnerUrl + configResultsCounts.getUrls().routeCounts;

    return {
      get: getCounts
    };
  }
);

